<!--
- phonecallTip 打电话提示
-->
<template>
  <van-popup class="phonecall-box" v-model="show" :close-on-click-overlay="false">
    <div class="phonecall-con">
      <div class="phonecall-close" @click="closePop"></div>
      <div class="phonecall-tipword">联系时请说明<br />信息来自搜好货网</div>
      <a :href="'tel:' + phoneNum" class="phonecall-btn"></a>
    </div>
  </van-popup>
</template>
<script>
export default {
  name: 'PhonecallTip',
  props: {
    show: {
      type: Boolean,
      default: false
    },
    phoneNum: {
      type: String,
      default: ''
    },
  },
  data() {
    return {}
  },
  methods: {
    closePop() {
      this.$emit('update:show', false);
    }
  },
}

</script>
<style lang="less">
.phonecall-box {
  background-color: transparent;
  overflow: initial;
}

.phonecall-con {
  width: 5.2rem;
  height: 6.41rem;
  background: url('../assets/images/phonecall-bg.png') no-repeat;
  background-size: 5.2rem 6.41rem;
  position: relative;
}

.phonecall-close {
  width: .5rem;
  height: .5rem;
  background: url('../assets/images/phonecall-close.png') no-repeat;
  background-size: .5rem .5rem;
  position: absolute;
  top: -.6rem;
  right: -.5rem;
}

.phonecall-tipword {
  font-size: .44rem;
  line-height: 1.7;
  color: #ff6700;
  padding: 3.06rem 0 .64rem 0;
  text-align: center;
}

.phonecall-btn {
  display: block;
  width: 3.4rem;
  height: .74rem;
  margin: 0 auto;
}

</style>
